<ion-grid class="ion-no-padding" style="height: 80%">
  <ion-row
    class="ion-no-padding ion-no-margin ion-justify-content-center ion-align-items-center"
    style="height: 100%; flex-direction: column"
  >
      <custom-icon
        iconName="COMING_SOON"
        [width]="203"
        [height]="203"
        colorClass="modalIcon"
      ></custom-icon>
      <p class="font20 font600 title-text-color">
        {{"page_status.coming_soon.header" | translate}}
      </p>
      <ion-text class="padb10 fs-3 font500 subtitle-text-color">
        {{"page_status.coming_soon.we_are_currently_working" | translate}}
      </ion-text>
      <ion-text class="fs-3 font500 subtitle-text-color">
        {{"page_status.coming_soon.stay_tuned" | translate}}
      </ion-text>
  </ion-row>
</ion-grid>
